import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
    standalone: false
})
export class TruncatePipe implements PipeTransform {
  transform(value: string | null, limit: number): string | null {
    if (value && value.length > limit) {
      return value.substring(0, limit) + '...';
    }
    return value;
  }
}
